import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import BulkActionModel, {
  type BulkActionCustomType,
  type BulkActionResponseType,
  type BulkActionType,
} from 'donor-elf-web/models/bulk-action';
import logger from 'donor-elf-web/lib/logger';

// takes care of creating a bulk action and waiting for it to complete
// You can also yield a block to display a message while waiting for the bulk action to complete

interface ComponentArgs {
  bulkActionType: BulkActionType;
  bulkActionCustom: BulkActionCustomType;
  onCompleted: (response: BulkActionResponseType) => void;
  onError: () => void; // this component will log the actual error
}

export default class BulkActionSaveComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    this.createBulkAction();
  }
  @service declare store: Store;

  @tracked bulkAction?: BulkActionModel;
  @tracked waitingOnBulkActionToComplete = false;
  @tracked saveError = false;

  async createBulkAction() {
    let bulkAction = this.store.createRecord('bulk-action');
    bulkAction.actionType = this.args.bulkActionType;
    bulkAction.custom = this.args.bulkActionCustom;
    await bulkAction.save();
    this.bulkAction = bulkAction;
    this.waitingOnBulkActionToComplete = true;
  }

  @action
  async handleBulkActionStatusChange(bulkAction: BulkActionModel) {
    if (bulkAction.status === 'completed') {
      try {
        const response = bulkAction.response!;

        await bulkAction.destroyRecord();
        this.args.onCompleted(response);

      } catch (error: any) {
        logger.error(error);
        this.saveError = true;
        this.args.onError();
      }
      this.waitingOnBulkActionToComplete = false;
    } else if (bulkAction.status === 'error') {
      logger.error(new Error(`A BulkAction error occurred for id "${bulkAction.id}"`));
      this.saveError = true;
      this.args.onError();
      this.waitingOnBulkActionToComplete = false;
    }
  }
}
